@if (isOpen()) {
  <div class="selection-toolbar">
    <span class="selection-toolbar__label">
      <button type="button" (click)="onClose.emit()" class="btn-M btn-text icon-only"><i class="far fa-xmark selection-toolbar__label-icon"></i></button>
      <p class="selection-toolbar__label-text">{{ label() }}</p>
    </span>

    <div class="selection-toolbar__buttons">
      <ng-content></ng-content>
    </div>
  </div>
}
